import { z } from 'zod';
import { order } from '@schuettflix/schema-registry-ts';

export const ProductFulfillmentEventSchema = order.fulfillmentService.versions.v1.schemas.PRODUCT_FULFILLED;

export type ProductFulfilmentEventPayload = z.infer<typeof ProductFulfillmentEventSchema>;
